import React, { useState } from 'react'
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Button,
  Typography,
  CircularProgress,
  Box
} from '@material-ui/core'

import classes from './index.module.scss'
import downloadFile from 'client-sdk/src/common/file/downloadFile'

type Props = {
  orderId: number
}

const DeliveryReceipt = (props: Props) => {
  const { orderId } = props
  const [isLoading, setIsLoading] = useState(false)

  const handlerDownloadFile = async () => {
    setIsLoading(true)
    try {
      const response = await downloadFile(
        orderId,
        'ORDER',
        'ORDER_DELIVERY_RECEIPT'
      )
      const blob = await response.blob
      const fileUrl = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = fileUrl
      if (response.blob.type.includes('image')) {
        link.setAttribute('download', 'order_receipt')
      } else if (response.blob.type.includes('pdf')) {
        link.setAttribute('download', 'order_receipt.pdf')
      }
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(fileUrl)
      setIsLoading(false)
    } catch (error) {
      console.error('Download error:', error)
    }
  }

  return (
    <Card className={classes.card}>
      <CardHeader
        avatar={
          <Typography className={classes.typographyCards}>
            رسید تحویل
          </Typography>
        }
      />
      <CardContent style={{ paddingBottom: '10px' }}>
        <Grid xs={12} sm={12} lg={12} spacing={2}>
          <Button
            disabled={isLoading}
            variant='outlined'
            size='large'
            fullWidth
            color='primary'
            style={{ marginLeft: '12px' }}
            onClick={handlerDownloadFile}
          >
            {`دانلود رسید تحویل`}
          </Button>
          {isLoading && (
            <Box style={{ position: 'relative' }}>
              <div className={classes.isLoadingStyle}>
                <CircularProgress />
              </div>{' '}
            </Box>
          )}
        </Grid>
      </CardContent>
    </Card>
  )
}

export default DeliveryReceipt
